import { getSession } from './getSession'

export const getToken = async ({ req }: { req?: any } = {}) => {
  const session = await getSession({ req })
  const token = session?.tokenEncoded
  return token
}
